@for (filter of filters; track filter) {
  @if (isHiddenField(filter)) {
    <input type="hidden" [formControl]="filter.formControl.value" />
  } @else {
    <div class="cm-row" [class.no-flex]="sidebarService.isLarge" [ngClass]="filter.cssClass || ''">
      @if (filter.type == 'template') {
        <ng-container
          *ngTemplateOutlet="filter.template; context: { filter: filter }"
        ></ng-container>
      } @else {
        @if (!filter.hideLabel) {
          <div
            class="cm-label"
            [class.required]="filter?.formControl?.value?.status == 'INVALID' && filter?.label != ' '"
            >
            {{ filter.label || (filter.formControl.key | camelToWords | titlecase) }}
          </div>
        }
        <div class="cm-field">
          @if (filter.type == 'text') {
            <lib-cm-input
              [titlecase]="isTitlecase(filter)"
              [formControl]="filter.formControl.value"
            placeholder="Enter {{
              filter.label || (filter.formControl.key | camelToWords | titlecase)
            }}"
              [highlightIfSet]="true"
              [clearable]="true"
              [disabled]="filter.disabled"
              id="{{ filter.id }}"
            ></lib-cm-input>
          }
          @if (filter.type == 'number') {
            <lib-cm-input
              [type]="filter.type"
              [formControl]="filter.formControl.value"
              [placeholder]="filter.placeholder"
              [highlightIfSet]="true"
              [clearable]="true"
              [disabled]="filter.disabled"
              id="{{ filter.id }}"
            ></lib-cm-input>
          }
          @if (filter.type == 'select') {
            <lib-cm-select
              [formControl]="filter.formControl.value"
              [collection]="filter.data"
              [clearable]="isClearable(filter)"
              [highlightIfSet]="true"
              [placeholder]="filter.placeholder"
              [deselectable]="isDeselectable(filter)"
              [viewValue]="filter.viewValue"
              [defaultValue]="filter.defaultValue"
              [valueForRequest]="filter.valueForRequest"
              [panelClass]="filter.panelClass"
              [keyValue]="filter.keyValue"
              [disabled]="filter.disabled"
              id="{{ filter.id }}"
              >
            </lib-cm-select>
          }
          @if (filter.type == 'datepicker') {
            <lib-cm-datepicker
              [formControl]="filter.formControl.value"
              [placeholder]="filter.placeholder"
              [disabled]="filter.disabled"
              [clearable]="true"
              [highlightIfSet]="true"
              id="{{ filter.id }}"
              >
            </lib-cm-datepicker>
          }
          @if (filter.type == 'datetimepicker') {
            <lib-cm-datetimepicker
              [formControl]="filter.formControl.value"
              [placeholder]="filter.placeholder"
              [disabled]="filter.disabled"
              id="{{ filter.id }}"
              >
            </lib-cm-datetimepicker>
          }
          @if (filter.type == 'daterangepicker') {
            <lib-cm-daterangepicker
              [group]="filter.formControl.value"
              (dateChange)="dateRangeChange($event, filter.formControl.value)"
              [disabled]="filter.disabled"
              id="{{ filter.id }}"
              >
            </lib-cm-daterangepicker>
          }
          @if (filter.type == 'autocomplete') {
            <lib-cm-autocomplete
              [formControl]="filter.formControl.value"
              [observableSourceFunction]="filter.data.sourceFun"
              [params]="filter.data.params"
              [placeholder]="filter.placeholder || 'Enter Name'"
              [highlightIfSet]="true"
              [clearable]="true"
              [viewValue]="filter.viewValue || 'name'"
              [valueForRequest]="filter.valueForRequest"
              [inputMask]="filter.inputMask"
              id="{{ filter.id }}"
              [disabled]="filter.disabled"
              [resetOptions]]="filter.resetOptions"
            ></lib-cm-autocomplete>
          }
          @if (filter.type == 'checkbox') {
            <lib-cm-checkbox
              [formControl]="filter.formControl.value"
              [disabled]="filter.disabled"
              [label]="filter.label"
              id="{{ filter.id }}"
            ></lib-cm-checkbox>
          }
          @if (filter.type == 'ssnAutocomplete') {
            <cms-ssn-autocomplete
              [formControl]="filter.formControl.value"
              [highlightIfSet]="true"
              [panelWidth]="null"
              id="{{ filter.id }}"
            ></cms-ssn-autocomplete>
          }
          @if (filter.type == 'labels') {
            <cms-labels
              [control]="filter.formControl.value"
            ></cms-labels>
          }
          @if (filter?.subInfo && filter?.formControl?.value?.value) {
            <span>{{
              filter?.formControl?.value.value[filter?.subInfo]
            }}</span>
          }
        </div>
      }
    </div>
  }
}
